module.exports = __webpack_public_path__ + "img/5.769a0ecb.png";